export default __webpack_public_path__ + "static/media/pix-negative.f2123004.svg";